// Decorative SecAggIBLT schematic, based on Google's public explanation:
// https://research.google/blog/improving-gboard-language-models-via-private-federated-analytics/
// Local sketches combine into an aggregate table; decoding recovers entries.
// Cell counts, hash collisions and cryptography are not simulated here.
const line = (points, extra = {}) => ({ points, ...extra });
const rect = (x, y, w, h, z) => [[x,y,z],[x+w,y,z],[x+w,y+h,z],[x,y+h,z],[x,y,z]];
function box(x, y, w, h, z, depth, extra = {}) {
    const front = rect(x,y,w,h,z), back = rect(x,y,w,h,z+depth);
    return [line(front,extra),line(back,extra),...front.slice(0,4).map((p,i)=>line([p,back[i]],extra))];
}

export function ibltGeometry() {
    const curves = [];
    const table = (x, y, cols, rows, cell, z, depth) => {
        curves.push(...box(x,y,cols*cell,rows*cell,z,depth));
        for (let c=1;c<cols;c++) curves.push(line([[x+c*cell,y,z],[x+c*cell,y+rows*cell,z]]));
        for (let r=1;r<rows;r++) curves.push(line([[x,y+r*cell,z],[x+cols*cell,y+r*cell,z]]));
    };
    // Separate local sketches meet at an aggregation junction. Only the
    // resulting aggregate has a path into the decoder/output side.
    for (let device=0;device<3;device++) {
        const y=-174+device*135;
        curves.push(...box(-432,y-12,58,92,0,12));
        curves.push(line(rect(-424,y,42,54,0)),line([[-413,y+67,0],[-395,y+67,0]]));
        table(-332,y,3,3,22,12,12);
        curves.push(line([[-374,y+30,0],[-332,y+30,12]]));
        const route=[[-266,y+33,12],[-206,y+33,12],[-155,0,30]];
        curves.push(line(route));
        for (let packet=0;packet<2;packet++) {
            curves.push(...box(-6,-6,12,12,0,7,{travel:{route,period:10,offset:device*1.6+packet*5}}));
        }
        // Three distinct occupied buckets hint at multi-hash insertion.
        for (let col=0;col<3;col++) {
            const row=(col+device)%3;
            curves.push(line(rect(-329+col*22,y+3+row*22,16,16,12)));
        }
    }
    curves.push(...box(-165,-10,20,20,20,20));
    const combined=[[-145,0,30],[-90,0,30]];
    curves.push(line(combined),...box(-8,-8,16,16,0,10,{travel:{route:combined,period:6,offset:1}}));

    // A stack of aligned 3 x 8 tables suggests linear aggregation.
    for (const z of [0,18,36]) table(-90,-144,3,8,36,z,6);
    for (let row=0;row<8;row++) {
        const col=(row*2+1)%3, x=-84+col*36, y=-138+row*36;
        curves.push(line(rect(x,y,24,24,42)));
        if (row%2===0) {
            const outY=-126+row*36;
            const route=[[x+12,y+12,42],[94,y+12,42],[176,outY,16],[306,outY,16]];
            curves.push(line(route),...box(-8,-8,16,16,0,8,{travel:{route,period:12,offset:row*1.2}}));
            curves.push(...box(306,outY-19,92,38,0,16));
            for(let token=0;token<3;token++) curves.push(line(rect(315+token*26,outY-10,18,20,16)));
        }
    }
    return { curves, labels: [
        {text:'SKETCHES',point:[-300,218,12]},
        {text:'SecAgg',point:[-155,70,30]},
        {text:'IBLT',point:[-36,184,36]},
        {text:'DECODE',point:[350,184,16]},
    ] };
}
